import { useFeatureServices } from './use-feature-services';

export const useGetWaidLitera = ()  => {
  const oneFormService = useFeatureServices()['es:oneform-core'];
  const waid = oneFormService.getDpsData().waid;

  return waid;
};
